import React from 'react';
import '../CSS/Profile/CharlesPrinceProfile.css';

const CharlesPrinceProfile: React.FC = () => {
  const imagePath = `${process.env.PUBLIC_URL || ''}/assets/Web Version/Team Page/Our Team/charles-prince-image.png`;
  const linkedInIcon = `${process.env.PUBLIC_URL || ''}/assets/Web Version/Icons/linkedin-blue-icon.svg`;

  return (
    <div className="profile-page">
      <div className="profile-header">
        <div className="profile-picture-container">
          <img 
            src={imagePath}
            alt="Charles B. W. Prince"
            className="profile-picture"
          />
        </div>
      </div>
      <div className="profile-content">
        <h1 className="profile-name">Charles B. W. Prince</h1>
        <div className="profile-title-container">
          <p className="profile-title">Managing Partner</p>
          <a href="https://www.linkedin.com/in/drcharlesprince/" target="_blank" rel="noopener noreferrer">
            <img 
              src={linkedInIcon}
              alt="LinkedIn"
              className="profile-linkedin-icon"
            />
          </a>
        </div>
        <div className="profile-desc">
          <p>
            <strong>Dr. Charles B. W. Prince</strong> joined Myers McRae as a Senior Consultant in 2026. He is a higher education executive with senior leadership experience in the United States and the United Kingdom, with particular strength in strategic planning, institutional transformation, accreditation, and board relations.
          </p>
          <p>
            Most recently, Dr. Prince served as Vice President for Academic Affairs, Institutional Advancement and Strategy at Shorter College (2025–2026), where he led the College’s 2026–2036 strategic plan and TRACS reaffirmation work. Earlier roles include Vice President and Chief of Staff in the Office of the President at Dillard University, where he authored $25 million in successful external funding; Vice President of Institutional Effectiveness and Interim Associate Provost at Virginia Union University; Strategic Leader at EAB, advising presidents and provosts nationally; and Acting Chief Operating Officer at the University of East London.
          </p>
          <p>
            Dr. Prince holds an Ed.D. from the University of Southern California, a master’s degree from The George Washington University, and a B.A. from Southwestern University. He is an AGB Leadership and Governance in Higher Education Fellow and has authored several books on higher education leadership and governance.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CharlesPrinceProfile;
